package com.exura.navigation

import com.varabyte.kobweb.core.PageContext
import com.varabyte.kobweb.navigation.OpenLinkStrategy
import com.varabyte.kobweb.navigation.UpdateHistoryMode

fun PageContext.navigateTo(
    pathQueryAndFragment: String,
    updateHistoryMode: UpdateHistoryMode = UpdateHistoryMode.PUSH,
    openInternalLinksStrategy: OpenLinkStrategy = OpenLinkStrategy.IN_PLACE,
    openExternalLinksStrategy: OpenLinkStrategy = OpenLinkStrategy.IN_NEW_TAB,
) {
    router.navigateTo(
        pathQueryAndFragment = pathQueryAndFragment,
        updateHistoryMode = updateHistoryMode,
        openInternalLinksStrategy = openInternalLinksStrategy,
        openExternalLinksStrategy = openExternalLinksStrategy,
    )
}
